import { Palette } from '@ppwr/poker'
import * as React from 'react'
import Svg, { Path, G, Circle, Defs, ClipPath, Rect } from 'react-native-svg'

interface AddBotsSVGProps {
  bgFill?: string
  iconFill?: string
}

export const AddBotsSVG = ({
  bgFill = Palette['Brand/Cream'],
  iconFill = Palette['Global/Black'],
  ...rest
}: React.ComponentProps<typeof Svg> & AddBotsSVGProps) => (
  <Svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...rest}>
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 6C17 3.23858 14.7614 1 12 1C9.23858 1 7 3.23858 7 6V8C7 10.7582 8.5952 13.1437 10.9133 14.2845C11.1496 13.8348 11.4273 13.4104 11.7415 13.0164C9.83032 12.1546 8.5 10.2327 8.5 8V6.5H12C12.8284 6.5 13.5 7.17157 13.5 8V11.3847C13.8177 11.1682 14.1518 10.9739 14.5 10.8042V8C14.5 6.61929 13.3807 5.5 12 5.5H8.53544C8.77806 3.80385 10.2368 2.5 12 2.5C13.933 2.5 15.5 4.067 15.5 6V10.3984C15.9814 10.2401 16.4831 10.1264 17 10.0619V6ZM10.252 16H8C4.64888 16 1.84776 18.3548 1.16109 21.5C1.05559 21.9832 1 22.4851 1 23H11.7546C11.3851 22.539 11.0656 22.0363 10.8042 21.5H2.70703C3.35996 19.1915 5.48245 17.5 8 17.5H10.0154C10.0471 16.9853 10.1275 16.4838 10.252 16Z"
      fill={iconFill}
    />
    <G clipPath="url(#clip0_8677_1455)">
      <Circle cx={18} cy={18} r={6} fill={iconFill} />
      <Path
        d="M18.375 15.1716C18.375 14.9645 18.2071 14.7966 18 14.7966C17.7929 14.7966 17.625 14.9645 17.625 15.1716L17.625 17.625L15.1716 17.625C14.9645 17.625 14.7966 17.7929 14.7966 18C14.7966 18.2071 14.9645 18.375 15.1716 18.375L17.625 18.375L17.625 20.8284C17.625 21.0355 17.7929 21.2034 18 21.2034C18.2071 21.2034 18.375 21.0355 18.375 20.8284L18.375 18.375H20.8284C21.0355 18.375 21.2034 18.2071 21.2034 18C21.2034 17.7929 21.0355 17.625 20.8284 17.625H18.375L18.375 15.1716Z"
        fill={bgFill}
      />
    </G>
    <Defs>
      <ClipPath id="clip0_8677_1455">
        <Rect width={12} height={12} fill={bgFill} transform="translate(12 12)" />
      </ClipPath>
    </Defs>
  </Svg>
)
